import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useQuestionCache } from './cache'
import { Logger, type QuestionRemoveInput, type QuestionRemoveSuccess, toResponseError } from '@terros/common'

const logger = new Logger('useRemoveQuestion')

export function useRemoveQuestion(): RemoveHookResponse<QuestionRemoveInput> {
  logger.verbose('calling useRemoveQuestion')
  const cache = useQuestionCache()
  const mutation = useTantalimMutation<QuestionRemoveInput, QuestionRemoveSuccess>({
    url: '/question/manage/remove',
  })

  async function remove(input: QuestionRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.questionId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
